module.exports = [{"value":null,"text":"=Please Select Your Account Type=","disabled":true,"selected":true},{"value":"Admin","text":"Admin"},{"value":"Trn","text":"Trainer"},{"value":"Wkr","text":"Worker"},{"value":"Con","text":"Contractor"}]


//////////////////
// WEBPACK FOOTER
// ./static/flagType.json
// module id = ./static/flagType.json
// module chunks = 0 7 10 12 14